module.exports = __webpack_public_path__ + "img/CY.7c010fe6.svg";